var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35986 17.68L16.9999 4.76001L32.6399 17.68",
    stroke: "#383434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5998 20.4H4.75977V28.56H13.5998V20.4Z",
    fill: "#6BE3A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2399 20.4H20.3999V28.56H29.2399V20.4Z",
    fill: "#6BE3A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75977 16.8832V28.5593H13.4462V20.3329H20.0269V28.5593H29.2398V16.8832",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4399 9.38694V4.76001H25.8399V12.24",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/Delivered.b0a29c92da36015a8bd4c570c8a34774.svg";
export { ForwardRef as ReactComponent };